import React, { useState } from "react";
import "./Contact.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSendQuery = (e) => {
    e.preventDefault();

    const phoneNumber = "9413188887"; // WhatsApp number
    const { name, email, mobile, message } = formData;

    if (!name || !email || !mobile) {
      alert("Please fill in all required fields.");
      return;
    }

    const whatsappMessage = `Tax O wealth - New Query:
Hello, I am ${name}.
Mobile: ${mobile}
Email: ${email}
Message: ${message || "No message provided."}`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;
    window.open(url, "_blank");

    // Show popup after submission
    setIsSubmitted(true);

    // Clear the form after sending
    setFormData({
      name: "",
      email: "",
      mobile: "",
      city: "",
      message: "",
    });

    // Remove the popup after 3 seconds
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  return (
    <div id="contact" className="contact-page">
      <h1 className="contact-title">CONTACT US</h1>
      <div className="contact-container">
        {/* Query Section */}
        <div className="query-section">
          <form className="contact-form" onSubmit={handleSendQuery}>
            <div className="form-group">
              <label htmlFor="name">
                Name <span>*</span>
              </label>
              <input
                type="text"
                id="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">
                E-mail <span>*</span>
              </label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="mobile">
                Mobile <span>*</span>
              </label>
              <input
                type="tel"
                id="mobile"
                placeholder="Enter your mobile number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                placeholder="Enter your city"
                value={formData.city}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                rows="4"
                placeholder="Write your message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button type="submit" className="send-btn">
              SEND
            </button>
          </form>
          {isSubmitted && (
            <div className="popup">
              Your query has been sent!
            </div>
          )}
        </div>

        {/* Map Section */}
        <div className="map-section">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.1840367295037!2d75.80353571500835!3d26.855947983153155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db533ad7b07db%3A0x5c8b3544d0e3b4b6!2s242%2C%20Patrakar%20Colony%20Swarn%20Path%2C%20Mansarovar%20Sector%204%2C%20Mansarovar%2C%20Jaipur%2C%20Rajasthan%20302020!5e0!3m2!1sen!2sin!4v1674805151684!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
          <div className="contact-details">
            <h2>Tax O Wealth Advisors</h2>
            <div className="contact-info">
              <p>
                <strong>Registered Office:</strong>
                <br />
                242, Patrakar Colony Mansarovar
                <br />
                Jaipur, Rajasthan
                <br />
                302020
              </p>
              <p>
                <strong>Contact Details:</strong>
                <br />
                Ph: 0141-4507527
                <br />
                Mob: 98293-26555, 94686-23539
                <br />
                Email:{" "}
                <a href="mailto:info@taxowealth.com">info@taxowealth.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
